import Button from '@cobliteam/ui/components/Button';
import Icon from '@cobliteam/ui/icons';
import { ControlPosition, MapControl, useMap } from '@vis.gl/react-google-maps';
import { useState } from 'react';

const ZOOM_LEVELS = [12, 13, 14, 15, 16, 17, 18];

const MapZoomControl = () => {
  const map = useMap();
  const [zoomLevel, setZoomLevel] = useState(map?.getZoom() || 12);

  const handleZoom = (direction: 'in' | 'out') => {
    const newZoomLevel = direction === 'in' ? zoomLevel + 1 : zoomLevel - 1;

    if (newZoomLevel >= ZOOM_LEVELS[0] && newZoomLevel <= ZOOM_LEVELS[ZOOM_LEVELS.length - 1]) {
      map?.setZoom(newZoomLevel);
      setZoomLevel(newZoomLevel);
    }
  };

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <div className='m-5 flex flex-col shadow-sm'>
        <Button
          onClick={() => handleZoom('in')}
          disabled={zoomLevel === ZOOM_LEVELS[ZOOM_LEVELS.length - 1]}
          variant='outlined'
          size='sm'
          color='default'
          icon={<Icon name='plus' />}
          aria-label='Zoom in'
          className='rounded-b-none border-b-0 bg-white'
        />
        <Button
          onClick={() => handleZoom('out')}
          disabled={zoomLevel === ZOOM_LEVELS[0]}
          variant='outlined'
          size='sm'
          color='default'
          icon={<Icon name='minus' />}
          aria-label='Zoom out'
          className='rounded-t-none bg-white'
        />
      </div>
    </MapControl>
  );
};

export default MapZoomControl;
